<template>
  <div class="manan_vasa">
    <!-- Navbar -->
    <!-- <navbar></navbar> -->
    <cq-master>


      <!-- Meet Manan Vasa-->
      <mv-meetmanan></mv-meetmanan>


      <!-- Manana's Mission -->
      <mv-mission></mv-mission>


      <!-- Manan's IP -->
      <mv-manans-ip></mv-manans-ip>

      <!-- Make It Happen -->
      <mv-makeithappen></mv-makeithappen>

      <!-- Million Dollar Habbits -->
      <mv-mdh></mv-mdh>

      <!-- Colloquium - 'The Gain Livinar -->
      <mv-colloquium></mv-colloquium>


      <!-- Manan Unleashed -->
      <mv-unleashed></mv-unleashed>


      <!-- Carousel -->
      <mv-carousel></mv-carousel>

    </cq-master>

    <!-- Upward Arrow -->
    <!-- <cq-uparrow></cq-uparrow>  -->


    <!-- Footer -->
    <!-- <cq-footer></cq-footer> -->
  </div>
</template>

<script>
import CQMaster from '@/components/layout/CQMaster.vue'
// import Navbar from '../components/layout/Navbar.vue'
import MVMeetManan from '../components/MananVasa/MV-MeetManan.vue'
import MVMission from '../components/MananVasa/MV-Mission.vue'
import MVManansIP from '../components/MananVasa/MV-ManansIP.vue'
import MVMakeItHappen from '../components/MananVasa/MV-MakeItHappen.vue'
import MVMDH from '../components/MananVasa/MV-MillionDollarHabbits.vue'
import MVColloquium from '../components/MananVasa/MV-Colloquium.vue'
import MVUnleashed from '../components/MananVasa/MV-Unleashed.vue'
import MVCarousel from '../components/MananVasa/MV-Carousel.vue'
// import CQUpArrow from '../components/ui/CQUpArrow.vue'
// import CQFooter from '../components/layout/CQFooter.vue'



export default {
  name: 'Manan_Vasa',
  components: {
    'cq-master' : CQMaster,
    // 'navbar' : Navbar,
    // 'mv-mdh' : MVMDH,
    'mv-meetmanan' : MVMeetManan, 
    'mv-mission' : MVMission,
    'mv-manans-ip' : MVManansIP,  
    'mv-makeithappen' : MVMakeItHappen,
    'mv-mdh' : MVMDH, 
    'mv-colloquium' : MVColloquium,
    'mv-unleashed' : MVUnleashed,
    'mv-carousel' : MVCarousel,
    // 'cq-uparrow' : CQUpArrow,
    // 'cq-footer' : CQFooter
  },
  

}
</script>

<style scoped>
  .red{
    color: var(--primary-color);
  }
</style>